module.exports = {
        srcSet: "/_next/static/images/groupSolutions-640.ae923711.webp"+" 640w"+","+"/_next/static/images/groupSolutions-828.4fa926f1.webp"+" 828w"+","+"/_next/static/images/groupSolutions-952.d7ed13c2.webp"+" 952w",
        images: [{path: "/_next/static/images/groupSolutions-640.ae923711.webp",width: 640,height: 705},{path: "/_next/static/images/groupSolutions-828.4fa926f1.webp",width: 828,height: 911},{path: "/_next/static/images/groupSolutions-952.d7ed13c2.webp",width: 952,height: 1048}],
        src: "/_next/static/images/groupSolutions-952.d7ed13c2.webp",
        toString: function(){return "/_next/static/images/groupSolutions-952.d7ed13c2.webp"},
        
        width: 952,
        height: 1048
      }